import { mobileDefaultPaddingLeft } from '../../../../../../../constants/sizes';
import Device from '../../../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center'
  },
  placesList: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: '0px 60px',
    [Device.mobile]: {
      justifyContent: 'space-around',
      padding: `0px ${mobileDefaultPaddingLeft}px`
    },
    width: '100%',
    boxSizing: 'border-box'
  },
  placeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '0px 30px',
    margin: '20px 0',
    [Device.mobile]: {
      padding: `0px ${mobileDefaultPaddingLeft}px`
    }
  },
  logo: {
    height: 50
  },
  title: {
    width: '100%'
  }
};
